import React, { useEffect, useState } from 'react';
import { Row, Col, message, Space, Typography, Button, Spin } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthlyReport } from '../ducks/actions'
import { exportInvoiceMonthlyReport } from '../ducks/services'
import Search from './components/Search'
import dayjs from 'dayjs';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { useTranslate } from 'Translate';
import { LoadingOutlined } from '@ant-design/icons';
import JsonView from 'react18-json-view';
import { Popup } from 'Atoms/Popup';

const { Title, Text } = Typography;
const antIcon = <LoadingOutlined spin />;

export default (props) => {
  const dispatch = useDispatch();
  const stockBalances = useSelector((state) => state.reporting.stockBalances);
  const meta = useSelector((state) => state.eInvoice.monthlyReportOption);
  const monthlyReportData = useSelector((state) => state.eInvoice.monthlyReport)
  const [searchVal, setSearchVal] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [einvoicePopUpVisible, setEinvoicePopUpVisible] = useState(false);
  const [rec, setRecord] = useState([]);
  const i18n = useTranslate();
  const { t } = i18n;
  const metaStatuses = meta?.e_invoice_statuses?.map(status => ({label: t(`General.${status}`), value: status}))
  const statusOptions = metaStatuses ? [{label: t("General.all_status"), value: ""}, ...metaStatuses] : []
  
  const colName = [
    {
      title: t("Outlet.code"),
      dataIndex: 'location_code',
      key: 'location_code',
      className: 'enable-click',
      sorter: false
    },
    {
      title: t("Outlet.venue"),
      dataIndex: 'location_desc',
      key: 'location_desc',
      className: 'enable-click',
      sorter: false
    },
    {
      title: t("General.date"),
      dataIndex: 'date',
      key: 'date',
      className: 'enable-click',
      sorter: false
    },
    {
      title: t("General.total_count"),
      dataIndex: 'total_count',
      key: 'total_count',
      className: 'enable-click',
      sorter: false,
      align: 'center',
    },
    {
      title: t("General.net_sales"),
      dataIndex: 'net_sales',
      key: 'net_sales',
      className: 'enable-click',
      sorter: false,
      align: 'right',
    },
    {
      title: t("General.tax_amount"),
      dataIndex: 'tax_amount',
      key: 'tax_amount',
      className: 'enable-click',
      sorter: false,
      align: 'right',
    },
    {
      title: t("General.rounding_adjustment"),
      dataIndex: 'rounding_adjustment',
      key: 'rounding_adjustment',
      className: 'enable-click',
      sorter: false,
      align: 'right',
    },
    {
      title: t("General.total_amount"),
      dataIndex: 'amount',
      key: 'amount',
      className: 'enable-click',
      sorter: false,
      align: 'right'
    },
    {
      title: t("General.submitted_count"),
      dataIndex: 'submitted_count',
      key: 'submitted_count',
      className: 'enable-click',
      sorter: false,
      align: 'center',
    },
    {
      title: t("General.submitted_net_sales"),
      dataIndex: 'submitted_net_sales',
      key: 'submitted_net_sales',
      className: 'enable-click',
      sorter: false,
      align: 'right',
    },
    {
      title: t("General.submitted_tax_amount"),
      dataIndex: 'submitted_tax_amount',
      key: 'submitted_tax_amount',
      className: 'enable-click',
      sorter: false,
      align: 'right',
    },
    {
      title: t("General.submitted_rounding_adjustment"),
      dataIndex: 'submitted_rounding_adjustment',
      key: 'submitted_rounding_adjustment',
      className: 'enable-click',
      sorter: false,
      align: 'right',
    },
    {
      title: t("General.submitted_amount"),
      dataIndex: 'submitted_amount',
      key: 'submitted_amount',
      className: 'enable-click',
      sorter: false,
      align: 'right'
    },
    {
      title: t("General.pending_count"),
      dataIndex: 'pending_count',
      key: 'pending_count',
      className: 'enable-click',
      sorter: false,
      align: 'center',
    },
    {
      title: t("General.pending_net_sales"),
      dataIndex: 'pending_net_sales',
      key: 'pending_net_sales',
      className: 'enable-click',
      sorter: false,
      align: 'center',
    },
    {
      title: t("General.pending_tax_amount"),
      dataIndex: 'pending_tax_amount',
      key: 'pending_tax_amount',
      className: 'enable-click',
      sorter: false,
      align: 'right'
    },
    {
      title: t("General.pending_rounding_adjustment"),
      dataIndex: 'pending_rounding_adjustment',
      key: 'pending_rounding_adjustment',
      className: 'enable-click',
      sorter: false,
      align: 'right'
    },
    {
      title: t("General.pending_amount"),
      dataIndex: 'pending_amount',
      key: 'pending_amount',
      className: 'enable-click',
      sorter: false,
      align: 'right'
    },
    {
      title: t("SalesReporting.e_invoice_status"),
      dataIndex: 'e_invoice_status',
      key: 'e_invoice_status',
      className: 'enable-click',
      align: 'center',
      sorter: true,
      // hidden: hideEinvoiceCol === "0",
      render: (text, record) =>
        <a className='pointer flex align-items-center' onClick={(e) => {
          e.stopPropagation()
          setEinvoicePopUpVisible(true)
          setRecord(record)
        }}>
          <span>{t(`General.${text?.toLowerCase()}`)}</span>
        </a>
    },
  ];

  useEffect(() => {
    dispatch(getMonthlyReport(1, limit, '', '', searchVal, props.setLoading));
  }, []);

  useEffect(() => {
    if(meta) {
      if('locations' in meta) {
        const temp = meta.locations.map(location => ({label: `${location.code} ${location.desc}`, value: location.id}))
        setOutlets(temp);
      }
    }
  }, [meta]);

  const exportCsv = async () => {
    if (stockBalances?.total_count === 0) {
      return message.warning(t("General.no_data_export"));
    }
    props.setLoading(true);

    await exportInvoiceMonthlyReport(searchVal).then((res) => {
      props.setLoading(false);
      if (res.data) {
        const aElement = document.createElement('a');
        let filename = res.headers["x-filename"];
        aElement.setAttribute('download', filename ?? "sample.pdf");
        const href = URL.createObjectURL(res.data);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const btnList = [
    {
      text: t("General.export_report"),
      classes: 'green-btn attendance-success',
      action: () => exportCsv(),
    },
  ];

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      let temp = [];
      if (search?.outlet?.length > 0) {
        search?.outlet?.map(x => {
          temp.push(x.value)
        });
      }

      searching = {
        start_date: search.start_date ? dayjs(search.start_date).startOf('month').format("YYYY-MM-DD") : "",
        end_date: search.end_date ? dayjs(search.end_date).startOf('month').format("YYYY-MM-DD") : "",
        e_invoice_status: search?.e_invoice_status.value
      };

      if (temp.length > 0) {
        searching["outlet"] = temp;
      }
      setSearchVal(searching);
      dispatch(getMonthlyReport(1, limit, '', '', searching, props.setLoading));
    } else {
      setSearchVal(null);
      dispatch(getMonthlyReport(1, limit, '', '', null, props.setLoading));
    }
  };

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getMonthlyReport(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
    } else {
      dispatch(getMonthlyReport(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
    }
  }

  const eInvoicePopUp = {
    closable: true,
    visibility: einvoicePopUpVisible,
    content: 
      <Space direction='vertical' size={20} className='w-100'>
        {/* <Title level={4} className='mb-0'>
          {rec?.order_no}
        </Title> */}
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
              <Title level={5} className='mb-0'>
                {t("General.status")}: <span className={`${rec?.status === "Paid" ? "c-success" : "c-danger"}`}>{rec?.e_invoice_status === "Paid" ? "Completed" : rec?.e_invoice_status}</span>
              </Title>

              {/* <Button 
                size='large' 
                className='green-btn'
                onClick={() => {
                  onProcessEinvoice(rec?.id)
                }}
              >
                  {t("General.sync")}
              </Button> */}
            </div>
          </Col>
        </Row>

        <Spin indicator={antIcon} size="large" spinning={false}>
          <div style={{display: 'grid', gridTemplateColumns: "300px 1fr", gap: "20px"}}>
            <div style={{display: "flex", flexDirection: "column", gap: "20px", position: "sticky", top: "0"}}>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.order_no")}</div>
                <div>{rec?.reference || "-"}</div>
              </div>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_status")}</div>
                <div>{rec?.e_invoice_status || "-"}</div>
              </div>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_date")}</div>
                <div>{rec?.e_invoice_date || "-"}</div>
              </div>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_uuid")}</div>
                <div>{rec?.e_invoice_uuid || "-"}</div>
              </div>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_long_id")}</div>
                <div>{rec?.e_invoice_long_id || "-"}</div>
              </div>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_url")}</div>
                {rec?.e_invoice_url ? <a href={rec?.e_invoice_url} target='_blank'>Preview</a> : <div>{"-"}</div>}
              </div>
            </div>

            <div style={{display: "flex", flexDirection: "column", gap: "20px"}}>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_res")}</div>
                <JsonView src={rec?.e_invoice_res} theme="default" />
              </div>
              <div style={{display: "flex", flexDirection: "column"}}>
                <div className='fwbold'>{t("SalesReporting.e_invoice_doc_raw")}</div>
                <JsonView src={rec?.e_invoice_doc_raw} theme="default" />
              </div>
            </div>
          </div>
        </Spin>
      
        <Row gutter={10} justify={'center'}>
          <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => {
            setEinvoicePopUpVisible(false);
            setRecord();
          }}>{t("General.close")}</Button></Col>
        </Row>
      </Space>
    ,
    width: "100%",
    onCancel: () => {
      setEinvoicePopUpVisible(false);
      setRecord();
    },
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("Menu.monthly_report")} btnList={allowed([AllRoles.INVENTORY_REPORTING.STOCK_BALANCE], 'write') ? btnList : null} />
        </Col>
        {/* refer to csv table layout */}
        <Col span={24} className="inv-report-sb">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            ListData={monthlyReportData?.list?.map(x => ({...x, key: x.id}))}
            ListCol={colName}
            field1={outlets}
            field2={statusOptions}
            onChange={onTableChange}
            pagination={{
              total: monthlyReportData?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...eInvoicePopUp} />
    </>
  )
}